
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".833","y":"1.667","width":"38.333","height":"25","rx":"2","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M2.5 1.667h35a1.667 1.667 0 011.667 1.667v23.333H.833V3.334A1.667 1.667 0 012.5 1.667z","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.167 31.667a1.667 1.667 0 01-1.667 1.667h-35a1.667 1.667 0 01-1.667-1.667v-5h38.334v5z","fill":"#fff","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20 33.333v5m-7.5 0h15","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 16l-5 2.87V27h5V16z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14 16l-5 2.87V27h5V16z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6 16l5 2.87V27H6V16z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6 16l5 2.87V27H6V16z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.5 13.333h5l1.25 3.333-2.083 1.667-1.667.833-3.75-2.5 1.25-3.333z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.167 26.667H5.833v-10l4.167 2.5 4.167-2.5v10zM10 19.167v7.5","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 13.334L10 7.917l2.5 5.417h-5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.833 16.667L9.23 8.514a.833.833 0 011.54 0l3.397 8.153m-6.945-3.334h5.556m8.055-6.666H30m-9.167 5h13.334m-13.334 5h13.334m-13.334 5H30","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    